import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=27a4a189&scoped=true&"
import script from "./SearchFilters.vue?vue&type=script&lang=js&"
export * from "./SearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=27a4a189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4a189",
  null
  
)

export default component.exports